module.exports = __webpack_public_path__ + "static/media/ppe_ear_pro.4b1f6152.png";